import { render, staticRenderFns } from "./ReportPagination.vue?vue&type=template&id=0ec1aba3&scoped=true&"
import script from "./ReportPagination.vue?vue&type=script&lang=js&"
export * from "./ReportPagination.vue?vue&type=script&lang=js&"
import style0 from "./ReportPagination.vue?vue&type=style&index=0&id=0ec1aba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1aba3",
  null
  
)

component.options.__file = "ReportPagination.vue"
export default component.exports